import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const TOC = ({ branch = "CSE", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Automata and Language Theory: Chomsky Classification, Finite Automata, Deterministic Finite Automata (DFA), Non-Deterministic Finite Automata (NFA), Regular Expressions, Equivalence of DFAs, NFAs and Regular Expressions, Closure properties of Regular grammar, Non-Regular Languages, Pumping Lemma.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Context Free Languages: Context Free Grammar (CFG), Parse Trees, Push Down Automata (deterministic and non-deterministic) (PDA), Equivalence of CFGs and PDAs, Closure properties of CFLs, Pumping Lemma, Parsing, LL(K) grammar.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Turing Machines and Computability Theory: Definition, design and extensions of Turing Machine, Equivalence of various Turing Machine Formalisms, Church-Turing Thesis, Decidability, Halting Problem, Reducibility and its use in proving undecidability, Rice's theorem, Undecidability of Post's correspondence problem, Recursion Theorem.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Complexity Theory: The class P as consensus class of tractable sets, Classes NP, co-NP, Polynomial time reductions, NP-completeness, NP-hardness, Cook-Levin theorem (With proof), Space complexity, PSPACE and NPSPACE complexity classes, Savitch theorem (With proof), Probabilistic computation, BPP class, Interactive proof systems and IP class, relativized computation and oracles.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Theory of Computation"
      subjectKey="toc"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'TOCNotes',
        videos: 'TOCVideos'
      }}
    />
  );
};

export default TOC;